import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D427 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D427 - Data Management - Applications </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 5.25 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            If you took your time and did the ZyBooks for D426, this course is
            going to be a breeze. I didn’t bother with any of the study
            materials—I just went straight to the labs and SQL coding.
          </p>
          <p>
            After that, I did the PA, scored high, took the OA, and passed.
            Pretty much didn’t even study for this course. But I did spend a lot
            of time studying for D426, which definitely helped.
          </p>
          <p>
            Study the ZyBooks material for D426, and you can ace this test
            easily.
          </p>
          <p>
            Also, this is a good read:
            <br />
            🔗{" "}
            <a href="https://www.reddit.com/r/WGU/comments/1csds0w/data_management_applications_d427_dans_guide/" rel="noreferrer" target="_blank">
              Dan’s Guide
            </a>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D427;
